module.exports = __webpack_public_path__ + "img/card-mastercard.87cb71b1.svg";